module.exports = __webpack_public_path__ + "media/images/flags/ru-f6bf75dc753a7e2944a7871bcdd29e60.svg";